export default __webpack_public_path__ + "static/media/img3.e4cb2b10.jpg";